/**
 * GENERATED by `npm run ads`. Do not edit by hand.
 *
 * Source images live in the `ads/` folder next to `app/`; this is the
 * downscaled, deployable set. Dimensions are here so the slot can reserve its
 * space before the image loads.
 */

export interface Ad {
  src: string
  width: number
  height: number
}

export const ADS: readonly Ad[] = [
  // Gemini_Generated_Image_2tzvbx2tzvbx2tzv.jpeg
  { src: '/ads/ad-d90ac64e.jpg', width: 600, height: 221 },
  // Gemini_Generated_Image_4wzj7x4wzj7x4wzj.jpeg
  { src: '/ads/ad-7126dc05.jpg', width: 600, height: 328 },
  // Gemini_Generated_Image_5kch15kch15kch15.jpeg
  { src: '/ads/ad-8c0cad80.jpg', width: 600, height: 221 },
  // Gemini_Generated_Image_6v9vtr6v9vtr6v9v.jpeg
  { src: '/ads/ad-a00bbe10.jpg', width: 600, height: 221 },
  // Gemini_Generated_Image_9731tu9731tu9731.jpeg
  { src: '/ads/ad-2f59c532.jpg', width: 600, height: 221 },
  // Gemini_Generated_Image_9ai0vp9ai0vp9ai0.jpeg
  { src: '/ads/ad-96379fd9.jpg', width: 600, height: 221 },
  // Gemini_Generated_Image_eo45sgeo45sgeo45.jpeg
  { src: '/ads/ad-d52320bb.jpg', width: 600, height: 221 },
  // Gemini_Generated_Image_xtc6s0xtc6s0xtc6.jpeg
  { src: '/ads/ad-b74819c4.jpg', width: 600, height: 221 },
  // round2/Gemini_Generated_Image_5dhfq05dhfq05dhf.jpeg
  { src: '/ads/ad-548e62eb.jpg', width: 600, height: 221 },
  // round2/Gemini_Generated_Image_65a30q65a30q65a3.jpeg
  { src: '/ads/ad-c19c5c2c.jpg', width: 600, height: 221 },
  // round2/Gemini_Generated_Image_edyoukedyoukedyo.jpeg
  { src: '/ads/ad-4a24656b.jpg', width: 600, height: 221 },
  // round2/Gemini_Generated_Image_exw8xrexw8xrexw8.jpeg
  { src: '/ads/ad-3af414b9.jpg', width: 600, height: 221 },
  // round2/Gemini_Generated_Image_irb357irb357irb3.jpeg
  { src: '/ads/ad-258fc23b.jpg', width: 600, height: 221 },
  // round2/Gemini_Generated_Image_rgacanrgacanrgac.jpeg
  { src: '/ads/ad-abaf5e6d.jpg', width: 600, height: 221 },
  // round2/Gemini_Generated_Image_umd9cmumd9cmumd9.jpeg
  { src: '/ads/ad-442698f5.jpg', width: 600, height: 221 },
  // round2/Gemini_Generated_Image_xzdekvxzdekvxzde.jpeg
  { src: '/ads/ad-12c3e997.jpg', width: 600, height: 221 },
]
